import React from 'react';


class Lista extends React.Component {

        constructor(props) {
          super(props);
          this.state = { Disabled: false };
      
          // Aqui utilizamos o `bind` para que o `this` funcione dentro da nossa callback
          this.handleClick = this.handleClick.bind(this);
        }
      
        handleClick() {
          this.setState(state => ({
            Disabled: !state.Disabled
          }));
        }
      
        render() {
          return (
            <button onClick={this.handleClick}>
              {this.state.Disabled ? 'ON' : 'OFF'}
            </button>
          );
        }
      }
      

export default Lista;